import InputRadioList from './InputRadioList';

export default InputRadioList;
